import React from 'react';

import Sidebar from 'client/common/components/sidebar';
import { ISidebarProps } from 'client/common/components/sidebar/sidebar';

import './index.css';

export default (props: ISidebarProps) => <Sidebar withScrollHandling {...props} />;
